import React, { useState, useEffect } from 'react'

import { ScrollTopIcon } from "../Icons/Icons"

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false)

  const handleScroll = () => {
    const yOffset = window.scrollY

    const showThreshold = 100

    if (yOffset > showThreshold) {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <button
      className={`fixed bottom-[50px] right-[50px] z-[999] transition-opacity duration-300 ease-in-out w-5 h-5 ${isVisible ? 'opacity-100' : 'opacity-0 hidden'}`}
      onClick={scrollToTop}
    >
      <ScrollTopIcon />
    </button>
  )
}

export default ScrollToTopButton
